// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q2ES","right":"styles_right__2ajGA"};